import type { SourcingHiringGoal } from 'api-clients/monolith';

import { useOpeningContext } from '@/contexts/opening-context';

/**
 * True when the metrics tab is on "hiring goal" but there's no active
 * hiring goal to show — callers should render `HiringGoalEmptyState`
 * instead of their normal content in that case.
 *
 * Takes `hiringGoal` as a parameter (rather than calling `useOpeningDetails()`
 * itself) so callers that already fetched it via their own `useOpeningDetails()`
 * call don't create a second observer on the same suspending query.
 */
export function useShowHiringGoalEmptyState(
  hiringGoal: SourcingHiringGoal | null,
): boolean {
  const { metricsViewMode } = useOpeningContext();
  return metricsViewMode === 'hiring_goal' && !hiringGoal?.external_id;
}
